
import { Serializable, JsonProperty } from "typescript-json-serializer";
@Serializable()
export class StateInstanceDTO {
    @JsonProperty()
    public flowId: string;

    @JsonProperty()
    public step: number;

    @JsonProperty()
    public stateKey: string;

    @JsonProperty()
    public stateName: string;

    @JsonProperty()
    public branchPriority?: number;

    @JsonProperty()
    public isRun: boolean;

    @JsonProperty()
    public remark?: string;

    @JsonProperty()
    public createDate?: number;

    public trackingNo?:string;
}